if not App.angularApp?
    return

App.angularApp.directive 'mfMentionSelection', () ->
    return {
        restrict: 'A'
        require: '^mfMentionContainer'
        scope: {
            mention: '='
        }
        link: (scope, elem, attrs, Cont) =>
            mention = scope.mention

            # On click update input text
            elem.on 'click', () =>
                mention_id = mention.user_records_id
                rpl = mention.username + ' '

                # If pattern is set
                if Cont.get('pattern')? and Cont.get('pattern') isnt ''
                    # Replace text in input with user name
                    old_text = Cont.get('text')
                    fnd = '@' + Cont.get('pattern')

                    new_text = old_text.replace(fnd, '@' + rpl)
                    Cont.setText(new_text)
                else
                    # Append replace text to end of text
                    Cont.setText(Cont.get('text') + rpl)

                # Reset pattern and close mentions list
                Cont.setPattern(null, false)

                # refocus cursor on input
                angular.element(Cont.input_elem).trigger('focus')

    }
